import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { FaHome, FaTh, FaUser } from 'react-icons/fa';
import { IoMdSettings } from 'react-icons/io';
import { settingTrue } from '../../../redux/actions';
import './MobileBottomNav.css';

// Mirrors the fixed bottom nav already hand-built inside DasgboardIndividual.tsx's
// mobile view, but as a shared component so any DashboardLayout page (not just the
// dashboard home) gets it — e.g. My Fundraisers.
const MobileBottomNav: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();

  const items = [
    { id: 'home', label: 'Home', icon: FaHome, active: location.pathname === '/dashboard', onClick: () => history.push('/dashboard') },
    { id: 'givehub', label: 'GiveHub', icon: FaTh, active: location.pathname === '/categories', onClick: () => history.push('/categories') },
    { id: 'profile', label: 'Profile', icon: FaUser, active: location.pathname === '/profile', onClick: () => history.push('/profile') },
    { id: 'settings', label: 'Settings', icon: IoMdSettings, active: false, onClick: () => dispatch(settingTrue(true)) },
  ];

  return (
    <div className="mobile-bottom-nav">
      {items.map((item) => (
        <div
          key={item.id}
          className={`mobile-bottom-nav-item ${item.active ? 'mobile-bottom-nav-item-active' : ''}`}
          onClick={item.onClick}
        >
          <item.icon className="mobile-bottom-nav-icon" />
          <span>{item.label}</span>
        </div>
      ))}
    </div>
  );
};

export default MobileBottomNav;
